import React, { createContext, useContext, useState, useEffect } from 'react';

const STORAGE_KEY = 'gita-audio-voice';

const AudioVoiceContext = createContext({
  voice: 'male',
  setVoice: () => {}
});

function readStoredVoice() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved === 'female' ? 'female' : 'male';
  } catch {
    return 'male';
  }
}

function writeStoredVoice(voice) {
  try {
    localStorage.setItem(STORAGE_KEY, voice);
  } catch {
    // Storage may be blocked in private mode or by browser settings.
  }
}

export function AudioVoiceProvider({ children }) {
  const [voice, setVoiceState] = useState(readStoredVoice);

  useEffect(() => {
    writeStoredVoice(voice);
  }, [voice]);

  const setVoice = (next) => {
    setVoiceState(next === 'female' ? 'female' : 'male');
  };

  return (
    <AudioVoiceContext.Provider value={{ voice, setVoice }}>
      {children}
    </AudioVoiceContext.Provider>
  );
}

export function useAudioVoice() {
  return useContext(AudioVoiceContext);
}
